import React, { useState, useEffect } from 'react';

const AnimatedRocket = ({ className = '' }) => {
	const [position, setPosition] = useState(30);

	useEffect(() => {
		const interval = setInterval(() => {
			setPosition((prev) => {
				if (prev <= -60) {
					return 30;
				}
				return prev - 2;
			});
		}, 50);

		return () => clearInterval(interval);
	}, []);

	return (
		<div
			className={`position-relative w-100 d-flex align-items-center justify-content-center ${className}`}
			style={{ height: '80px' }}
		>
			<div className="position-relative">
				<img
					src="https://d4kq6pyeqevai.cloudfront.net/static/images/rocket.gif"
					alt="Rocket"
					style={{
						width: '96px',
						height: '120px',
						objectFit: 'contain',
						transform: `translateY(${position}px)`,
						transition: 'transform 0.05s linear',
						filter: 'drop-shadow(0 4px 6px rgba(0, 0, 0, 0.1))'
					}}
				/>
			</div>
		</div>
	);
};

export default AnimatedRocket;
